import React from 'react';

function Hello() {
    return (
        <>
            <h1>Hello Shehan</h1>
            <p>This is awesome</p>
            <h3>Another tag</h3>
        </>
    )
}

export default Hello;